import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {AuthService} from '../../../auth/AuthService';
import {ActivatedRoute, Router} from '@angular/router';
import {first} from 'rxjs/operators';
import swal from "sweetalert2";
import {ProviderService} from '../../../Services/provider.service';
import {statesDropdown} from '../../../shared/StatesUS';


@Component({
    selector: 'pm-add-update-provider',
    templateUrl: './add-update-provider.component.html',
    styleUrls: ['./add-update-provider.component.css']
})

export class AddUpdateProviderComponent implements OnInit {
    providerForm!: FormGroup;
    isProviderSelected: boolean = false;
    id :any;
    staffId:any;
    type:any;
    status:boolean = false;
    providerType: any = [
        {value: 'INDIVIDUAL', viewValue: 'Individual'},
        {value: 'ORGANIZATION', viewValue: 'Organization'},
    ];
    phoneType: any = [
        {value: 'Mobile', viewValue: 'Mobile'},
        {value: 'Work', viewValue: 'Work'},
        {value: 'Home', viewValue: 'Home'},
    ];
    uType: any =[
        {value: true, viewValue: 'Yes'},
        {value: false, viewValue: 'No'},
    ];

    stateList:any = statesDropdown

    alreadyAUser:boolean= false

    OfficeType:any =[];
    readonly SELECT_ALL_OFFICES = '__SELECT_ALL_OFFICES__';
    sType:any=[
        {value: 'MANAGER', viewValue: 'Manager'},
        {value: 'SUPERVISOR', viewValue: 'Supervisor'},
        {value: 'PROVIDER', viewValue: 'Provider'},
        {value: 'team-member', viewValue: 'Team member'},
        {value: 'RECEPTIONIST', viewValue: 'Receptionist'},
        {value: 'NURSE', viewValue: 'Nurse'}
    ];
    constructor(private fb: FormBuilder,
                private providerServices: ProviderService,
                public authService: AuthService,
                private activatedRoute: ActivatedRoute,
                private route: Router) {

        this.id = this.activatedRoute.snapshot.paramMap.get('id');
        this.type = this.activatedRoute.snapshot.queryParams?.type

        this.providerForm = this.fb.group({
            id: [],
            staffType:[null],
            providerIsUser:[null, Validators.required],
            firstName: [null, Validators.required],
            lastName: [null, Validators.required],
            officeIds: [[], Validators.required],
            number: [null, [Validators.pattern(/^\d{10}$|^\d{3}-\d{3}-\d{4}$/)]],
            phoneType: [null],
            type: [null],
            email: [null, [ Validators.email]],
            license: [null],
            degree: [null],
            salutation: [null],
            firstLine: [null],
            secondLine: [null],
            city: [null],
            state: [null],
            zip: [null],
            npi: [null],
            taxId: [null],
        });

        if (this.type) {

            if(this.type === 'provider'){
                const reqData = {
                    providerId: this.id,
                    clientId: this.authService.clientId,

                };
                this.providerServices.getProviderDetails(reqData).pipe(first()).subscribe(
                    (response: any) => {
                       // console.log('API Response:', response); // Debug to confirm the response structure
                        if (response) {
                            const data = response;// Use `response` directly as it's a single object
                            // this.status = data?.active ? data?.active : false  ;
                            this.status = data.active ? data.active : false
                            this.alreadyAUser = data.providerIsUser ? data.providerIsUser : false,
                                this.providerForm.patchValue({
                                    id: data.id || null,
                                    firstName: data.firstName || null,
                                    lastName: data.lastName || null,
                                    staffType: data?.staffType || null,
                                    officeIds:  data?.officeIds || [],
                                    phoneType: data.contact?.phones[0]?.phoneType || null,
                                    providerIsUser : data.providerIsUser ? data.providerIsUser : false,
                                    type: data.type || null,
                                    license: data.license || null,
                                    degree: data.degree || null,
                                    salutation: data?.salutation || null,
                                    firstLine: data.address?.firstLine || null,
                                    secondLine: data.address?.secondLine || null,
                                    city: data.address?.city || null,
                                    state: data.address?.state || null,
                                    zip: data.address?.zip || null,
                                    email: data.contact?.email || null,
                                    number: data.contact?.phones[0]?.number || null,
                                    npi: data.npi || null,
                                    taxId: data.taxId || null,
                                });
                            // console.log('Form after patching:', this.providerForm.value); // Debug to confirm patched values
                        } else {
                            swal.fire({
                                title: 'Error!',
                                icon: 'error',
                                text: 'No data found!',
                                showConfirmButton: false,
                                timer: 5000,
                            });
                        }
                    },
                    (error) => {
                        console.error('Error fetching provider details:', error);
                        swal.fire({
                            title: 'Error!',
                            icon: 'error',
                            text: error.error.message,
                            showConfirmButton: false,
                            timer: 5000,
                        });
                    }
                );
            }
            if(this.type === 'staff'){
                const reqData = {
                    staffId: this.id,
                    clientId: this.authService.clientId,

                };
                this.providerServices.getStaffDetails(reqData).pipe(first()).subscribe(
                    (response: any) => {
                        // console.log('API Response:', response); // Debug to confirm the response structure
                        if (response) {
                            const data = response;// Use `response` directly as it's a single object
                            // this.status = data?.active ? data?.active : false  ;
                            this.status = data.active ? data.active : false
                            this.alreadyAUser = data?.staffIsUser ? data.staffIsUser : false,
                                this.providerForm.patchValue({
                                    id: data.id || null,
                                    firstName: data.firstName || null,
                                    lastName: data.lastName || null,
                                    staffType: data?.staffType || null,
                                    officeIds: data?.officeIds || [],
                                    phoneType: data?.contact?.phones[0]?.phoneType || null,
                                    providerIsUser : data?.staffIsUser ? data.staffIsUser : false,
                                    type: data?.type || null,
                                    degree: data?.degree || null,
                                    salutation: data?.salutation || null,
                                    firstLine: data?.address?.firstLine || null,
                                    secondLine: data?.address?.secondLine || null,
                                    city: data?.address?.city || null,
                                    state: data?.address?.state || null,
                                    zip: data?.address?.zip || null,
                                    email: data?.contact?.email || null,
                                    number: data?.contact?.phones[0]?.number || null,
                                });
                            // console.log('Form after patching:', this.providerForm.value); // Debug to confirm patched values
                        } else {
                            swal.fire({
                                title: 'Error!',
                                icon: 'error',
                                text: 'No data found!',
                                showConfirmButton: false,
                                timer: 5000,
                            });
                        }
                    },
                    (error) => {
                        console.error('Error fetching provider details:', error);
                        swal.fire({
                            title: 'Error!',
                            icon: 'error',
                            text: error.error.message,
                            showConfirmButton: false,
                            timer: 5000,
                        });
                    }
                );
            }
        }

    }

    ngOnInit(): void {
        this.providerForm.get('staffType')?.valueChanges.subscribe((value) => {
            this.isProviderSelected = value === 'PROVIDER';
        });
        let params = {
            isOfficeNameAndId:true,
            clientId: this.authService.clientId
        }
        this.providerServices.getAllOffice(params).pipe(first()).subscribe(
            (response: any) => {
                if (response) {
                    this.OfficeType = response
                }
            });
    }

    // Helper function to clean null values from objects
    private cleanNulls(obj: any): any {
        const cleanedObj = { ...obj };
        Object.keys(cleanedObj).forEach(key => {
            if (cleanedObj[key] === null || cleanedObj[key] === undefined) {
                delete cleanedObj[key];
            }
        });
        // Return undefined if the object is empty after cleaning (this skips adding the object to reqData)
        return Object.keys(cleanedObj).length ? cleanedObj : undefined;
    }

    private getCleanedContact(contact: any): any {
        // Clean null values from the phones array
        contact.phones = contact.phones.filter((phone:any) => phone.phoneType || phone.number);

        // Clean up phone objects
        contact.phones = contact.phones.map((phone:any) => ({
            ...phone,
            id: phone.id || null, // Remove `id` if null
            // active: phone.active ?? false, // Ensure active is always true if not set
        }));

        // Remove contact `id` if null
        contact.id = contact.id || null;

        // Ensure `active` is always set (default to true)
        // contact.active = contact.active ?? false;

        // If both email and cleaned phones are empty or null, return null
        if (!contact.email && contact.phones.length === 0) {
            return null;
        }

        // Clean null values from contact and return
        return this.cleanNulls(contact);
    }

    // Change status
    changeStatus(status:any){
        if(status == true){
            this.status = false;
        }else{
            this.status = true;
        }
    }

    onOfficeSelectionChange(event: any): void {
        const selectedValues: any[] = event.value || [];

        if (!selectedValues.includes(this.SELECT_ALL_OFFICES)) {
            return;
        }

        const allOfficeIds = this.OfficeType.map(
            (office: any) => office.id
        );

        const selectedOfficeIds = selectedValues.filter(
            (value: any) => value !== this.SELECT_ALL_OFFICES
        );

        const allAlreadySelected =
            allOfficeIds.length > 0 &&
            allOfficeIds.every(
                (id: any) => selectedOfficeIds.includes(id)
            );

        this.providerForm
            .get('officeIds')
            ?.setValue(
                allAlreadySelected
                    ? []
                    : allOfficeIds,
                { emitEvent: false }
            );
    }

    // Register provider function / update
    onRegister(): void {
        let reqData:any = {};
        let formData:any;

        // Mark all form fields as touched to trigger validation messages
        this.providerForm.markAllAsTouched();

        let redirectToUserCreation = false;

        if (this.providerForm.valid) {
            // Prepare request payload
            reqData = {
                id: this.providerForm.controls.id?.value || null,
                // active: this.providerForm.controls.status?.value || null, // Assuming the default value is true; you can adjust based on the form
                type: this.providerForm.controls.type.value,
                firstName: this.providerForm.controls.firstName.value,
                lastName: this.providerForm.controls.lastName.value,
                npi: this.providerForm.controls.npi.value,
                taxId: this.providerForm.controls.taxId.value,
                address: this.cleanNulls( {
                    id: this.providerForm.controls.addressId?.value || null, // Include `id` only if it exists
                    // active: true, // Assuming the address is active
                    firstLine: this.providerForm.controls.firstLine.value,
                    secondLine: this.providerForm.controls.secondLine.value,
                    city: this.providerForm.controls.city.value,
                    state: this.providerForm.controls.state.value,
                    zip: this.providerForm.controls.zip.value,
                }),
                contact: this.getCleanedContact( {
                    id: this.providerForm.controls.contactId?.value || null, // Include `id` only if it exists
                    // active: true, // Assuming the contact is active
                    phones: [
                        {
                            id: this.providerForm.controls.phoneId?.value || null, // Include `id` only if it exists
                            // active: true, // Assuming the phone is active
                            number: this.providerForm.controls.number.value,
                            phoneType: this.providerForm.controls.phoneType.value,
                        },
                    ],
                    email: this.providerForm.controls.email.value,
                }),
                license: this.providerForm.controls.license.value,
                degree: this.providerForm.controls.degree.value,
                salutation: this.providerForm.controls.salutation.value,
                staffType: this.providerForm.controls.staffType.value,
                providerIsUser : this.providerForm.controls.providerIsUser.value,
                officeIds: this.providerForm.controls.officeIds?.value || [],
                active: this.status,
            };

            formData = reqData;

            if (this.type === 'provider') {
                // Update provider logic
                const params = {
                    providerId: this.id,
                    // clientId: this.authService.clientId,
                };

                this.providerServices.updateProvider(reqData, params).pipe(first()).subscribe(
                    (response: any) => {
                        formData.providerId = this.id;
                        formData.staffType = reqData.staffType;
                        this.handleSuccess(response, reqData.firstName, 'updated', formData.providerIsUser, formData);
                    },
                    (error) => this.handleError(error)
                );
            } else {
                // Add/Register provider logic
                this.providerServices.providerRegistration(reqData).pipe(first()).subscribe(
                    (response: any) => {
                        formData.staffType = reqData.staffType;
                        if(response?.id){
                            formData.providerId = response.id
                        }
                        this.handleSuccess(response, reqData.firstName, 'registered', formData.providerIsUser, formData);
                    },
                    (error) => this.handleError(error)
                );
            }
        } else {
            console.error('Form is invalid:', this.providerForm.value); // Debugging invalid form values
        }
    }
    // Register staff function / update
    onStaffRegister(): void{
        let reqData:any = {};
        let formData:any;

        // Mark all form fields as touched to trigger validation messages
        this.providerForm.markAllAsTouched();

        // Initialize redirection flag
        let redirectToUserCreation = false;

        if (this.providerForm.valid) {
            // Prepare request payload
            reqData = {
                id: this.providerForm.controls.id?.value || null,
                // active: this.providerForm.controls.status?.value || null, // Assuming the default value is true; you can adjust based on the form
                type: this.providerForm.controls.type.value,
                firstName: this.providerForm.controls.firstName.value,
                lastName: this.providerForm.controls.lastName.value,
                npi: this.providerForm.controls.npi.value,
                taxId: this.providerForm.controls.taxId.value,
                address: {
                    id: this.providerForm.controls.addressId?.value || null, // Include `id` only if it exists
                    active: true, // Assuming the address is active
                    firstLine: this.providerForm.controls.firstLine.value,
                    secondLine: this.providerForm.controls.secondLine.value,
                    city: this.providerForm.controls.city.value,
                    state: this.providerForm.controls.state.value,
                    zip: this.providerForm.controls.zip.value,
                },
                contact: {
                    id: this.providerForm.controls.contactId?.value || null, // Include `id` only if it exists
                    active: true, // Assuming the contact is active
                    phones: [
                        {
                            id: this.providerForm.controls.phoneId?.value || null, // Include `id` only if it exists
                            active: true, // Assuming the phone is active
                            number: this.providerForm.controls.number.value,
                            phoneType: this.providerForm.controls.phoneType.value,
                        },
                    ],
                    email: this.providerForm.controls.email.value,
                },
                license: this.providerForm.controls.license.value,
                degree: this.providerForm.controls.degree.value,
                salutation: this.providerForm.controls.salutation.value,
                staffType: this.providerForm.controls.staffType.value,
                staffIsUser : this.providerForm.controls.providerIsUser.value,
                officeIds:this.providerForm.controls.officeIds?.value || [],
                active: this.status,
            };

            formData = reqData;

            if (this.type === 'staff' && this.id) {
                // Update provider logic
                const params = {
                    staffId: this.id,
                    //clientId: this.authService.clientId,
                };

                this.providerServices.updateStaff(reqData, params).pipe(first()).subscribe(
                    (response: any) => {
                        formData.staffId = this.id;
                        formData.staffType = reqData.staffType;
                        this.handleSuccess(response, reqData.firstName, 'updated', formData.staffIsUser, formData);
                    },
                    (error) => this.handleError(error)
                );
            } else {
                // Add/Register provider logic
                this.providerServices.staffRegistration(reqData).pipe(first()).subscribe(
                    (response: any) => {
                        formData.staffType = reqData.staffType;
                        if(response?.id){
                            formData.staffId = response.id
                        }
                        this.handleSuccess(response, reqData.firstName, 'registered', formData.staffIsUser, formData);
                    },
                    (error) => this.handleError(error)
                );
            }
        } else {
            console.error('Form is invalid:', this.providerForm.value); // Debugging invalid form values
        }
    }

// Handle successful response for both add and update operations
    private handleSuccess(response: any, providerName: string, action: string,redirectToUserCreation: boolean, formData:any): void {
        if (response) {
            swal.fire({
                icon: 'success',
                text: `"${providerName}" ${action} successfully.`,
                showConfirmButton: false,
                timer: 3000,
            }).then(() => {
                // Check if the user field is "Yes"
                if (formData.providerIsUser === true || formData?.staffIsUser === true) {
                    // console.log('User is Yes. Sending data to Subject:', formData);
                    this.providerServices.userData.next(formData); // Pass data to Subject
                }
                // Navigate to the listing page
                this.route.navigate(['provider']).then(() => {
                    // If the redirect flag is true, navigate to the user creation page
                    if (redirectToUserCreation) {
                        if(!this.alreadyAUser && (formData?.providerIsUser || formData?.staffIsUser)){
                            this.route.navigate(['/user/creation']);
                        }
                    }
                });
            });
        } else {
            swal.fire({
                title: 'Error!',
                icon: 'error',
                text: 'Unexpected error occurred. Please try again.',
                showConfirmButton: false,
                timer: 5000,
            });
        }
    }

// Handle error response for both add and update operations
    private handleError(error: any): void {
        console.error('Error:', error);
        swal.fire({
            title: 'Error!',
            icon: 'error',
            text: error?.error?.message || 'An unexpected error occurred.',
            showConfirmButton: false,
            timer: 5000,
        });
    }
}
